import BaseCrudService from "./baseCrud.service";

// Performance: cache estático para deduplicação de requests entre instâncias
const _pendingRequests = {};

function deduplicatedRequest(key, requestFn) {
	if (_pendingRequests[key]) return _pendingRequests[key];
	_pendingRequests[key] = requestFn().finally(() => {
		delete _pendingRequests[key];
	});
	return _pendingRequests[key];
}

// Performance: cache de dados já carregados (persistente até reload)
const _dataCache = {};

function cachedRequest(key, requestFn) {
	if (_dataCache[key]) return Promise.resolve(_dataCache[key]);
	return deduplicatedRequest(key, requestFn).then(data => {
		_dataCache[key] = data;
		return data;
	});
}

export default class CampaignService extends BaseCrudService {

	constructor() {
		super('Campaign');
	}

	listAllPaymentMethod(callback) {
		this.getRequest('ListAllPaymentMethod').then(callback);
	}

	listAllPaymentMethodProvider(callback){
		this.getRequest('ListAllPaymentMethodProviders').then(callback);
	}
	
	listAllDonationRecurrencePeriod(callback) {
		this.getRequest('ListAllDonationRecurrencePeriod').then(callback);
	}

	listAllDonationRecurrencePeriodByCampaign(callback) {
		this.getRequest('ListAllDonationRecurrencePeriodByCampaign').then(callback);
	}

	listAllTicketConfig(callback) {
		this.getRequest('FindAllTicketConfig').then(callback);
	}

	listConsentTermsByCampaignId(campaignId, callback) {
		this.getRequest('ListConsentTermsByCampaignId', {campaignId}).then(callback);
	}

	save(callback, campaign) {
		this.postRequest('Save', campaign).then(callback);
	}

	// Appreciation
	listAppreciationsByCampaignId(campaignId) {
		return this.getRequest('ListAppreciationsByCampaignId', { id: campaignId });
	}

	saveAppreciation(callback, campaignAppreciation) {
		this.postRequest('SaveAppreciation', campaignAppreciation).then(callback);
	}

	deleteAppreciation(callback, appreciationId) {
		this.deleteRequest('DeleteAppreciation', { id: appreciationId }).then(callback);
	}

	// Testimony
	listTestimoniesByCampaignId(callback, campaignId) {
		this.getRequest('ListTestimoniesByCampaignId', { id: campaignId }).then(callback);
	}

	async saveTestimony(callback, testimony) {
		await this.postRequest('SaveTestimony', testimony).then(callback);
	}

	async deleteTestimony(callback, testimonyId) {
		this.deleteRequest('DeleteTestimony', { id: testimonyId }).then(callback);
	}

	// News
	listNewsByCampaignId(callback, campaignId) {
		this.getRequest('ListNewsByCampaignId', { id: campaignId }).then(callback);
	}

	saveNews(callback, news) {
		this.postRequest('SaveNews', news).then(callback);
	}

	deleteNews(callback, newsId) {
		this.deleteRequest('DeleteNews', { id: newsId }).then(callback);
	}

	// Image
	listImagesByCampaignId(callback, campaignId) {
		this.getRequest('ListImagesByCampaignId', { id: campaignId }).then(callback);
	}

	saveImage(callback, image) {
		this.postRequest('SaveImage', image).then(callback);
	}

	deleteImage(callback, imageId) {
		this.deleteRequest('DeleteImage', { id: imageId }).then(callback);
	}

	// Partner
	listPartnersByCampaignId(callback, campaignId) {
		this.getRequest('ListPartnersByCampaignId', { id: campaignId }).then(callback);
	}

	savePartner(callback, partner) {
		this.postRequest('SavePartner', partner).then(callback);
	}

	deletePartner(callback, partnerId) {
		this.deleteRequest('DeletePartner', { id: partnerId }).then(callback);
	}

	// GiftConfig
	getGiftConfigByCampaignId(callback, campaignId) {
		this.getRequest('GetGiftConfigByCampaignId', { campaignId: campaignId }).then(callback);
	}

	saveGiftConfig(giftConfig){
		this.postRequest('SaveGiftConfig', giftConfig);
	}
		
	// Cases
	listCasesByCampaignId(callback, campaignId) {
		this.getRequest('ListCasesByCampaignId', { id: campaignId }).then(callback);
	}

	saveCase(callback, campaignCase) {
		this.postRequest('SaveCase', campaignCase).then(callback);
	}

	deleteCase(callback, caseId) {
		this.deleteRequest('DeleteCase', { id: caseId }).then(callback);
	}

	// Donation Steps
	listDonationStepsByCampaignId(callback, campaignId) {
		this.getRequest('ListDonationStepsByCampaignId', { id: campaignId }).then(callback);
	}

	saveDonationStep(callback, donationStep) {
		this.postRequest('SaveDonationStep', donationStep).then(callback);
	}

	deleteDonationStep(callback, donationStepId) {
		this.deleteRequest('DeleteDonationStep', { id: donationStepId }).then(callback);
	}

	// Campaign Product
	listCampaignProductByCampaignId(campaignId) {
		return this.getRequest('listCampaignProductByCampaignId', { id: campaignId });
	}

	findCampaignProduct(campaignProductId) {
		return this.getRequest('FindCampaignProduct', { campaignProductId: campaignProductId });
	}

	findCampaignProductByCustomUrl(campaignProductCustomUrl, showMessage = true, showLoader = true) {
		return this.getRequest('findCampaignProductByCustomUrl', { campaignProductCustomUrl: campaignProductCustomUrl }, showMessage, showLoader);
	}

	saveCampaignProduct(callback, campaignProduct) {
		this.postRequest('SaveCampaignProduct', campaignProduct).then(callback);
	}

	deleteCampaignProduct(callback, campaignProductId) {
		this.deleteRequest('DeleteCampaignProduct', { id: campaignProductId }).then(callback);
	}

	// Campaign Gift
	
	// Campaign Gift
	listCampaignGiftByCampaignId(campaignId = null) {
		return this.getRequest('listCampaignGiftByCampaignId', {campaignId: campaignId}, null, false);
	}

	findCampaignGift(campaignGiftId) {
		return this.getRequest('FindCampaignGift', { campaignGiftId: campaignGiftId });
	}

	findCampaignGiftByCustomUrl(campaignGiftCustomUrl, showMessage = true, showLoader = true) {
		return this.getRequest('findCampaignGiftByCustomUrl', { campaignGiftCustomUrl: campaignGiftCustomUrl }, showMessage, showLoader);
	}

	saveCampaignGift(callback, campaignGift) {
		this.postRequest('SaveCampaignGift', campaignGift).then(callback);
	}

	deleteCampaignGift(callback, campaignGiftId) {
		this.deleteRequest('DeleteCampaignGift', { id: campaignGiftId }).then(callback);
	}

	// Photo cards
	listPhotoCardsByCampaignId(callback, campaignId) {
		this.getRequest('ListPhotoCardsByCampaignId', { id: campaignId }).then(callback);
	}

	savePhotoCards(callback, donationStep) {
		this.postRequest('SavePhotoCards', donationStep).then(callback);
	}

	deletePhotoCards(callback, donationStepId) {
		this.deleteRequest('DeletePhotoCards', { id: donationStepId }).then(callback);
	}

	getMetaSubdomainAndOrProjectId(subDomain){
		return this.getRequest("FindBySubdomainAndOrProjectId", {subdomain: subDomain}, true, true);
	}

	getSkin(callback) {
		this.getRequest("GetSkin").then(callback);
	}

	getCampaignLandingPageConfigBySubdomain(showLoader = true) {
		// Performance: cache + deduplicação — evita múltiplas chamadas simultâneas
		return cachedRequest('landingPageConfig', () =>
			this.getRequest("GetCampaignLandingPageConfigBySubdomain", null, true, showLoader)
		);
	}

	calculateCampaignValues(campaignId) {
		return this.getRequest("CalculateCampaignValues", { campaignId: campaignId }, true, false);
	}

	getCampaignCaseList(campaignId) {
		return this.getRequest("GetCampaignCaseList", { campaignId: campaignId }, true, false);
	}

	getCampaignPhotoCardsList(campaignId) {
		return this.getRequest("GetCampaignPhotoCardsList", { campaignId: campaignId }, true, false);
	}

	getCampaignDonationStepList(campaignId) {
		return this.getRequest("GetCampaignDonationStepList", { campaignId: campaignId }, true, false);
	}

	getCampaignAppreciationList(campaignId) {
		return this.getRequest("GetCampaignAppreciationList", { campaignId: campaignId }, true, false);
	}

	getCampaignImageList(campaignId) {
		return this.getRequest("GetCampaignImageList", { campaignId: campaignId }, true, false);
	}

	getCampaignNewsList(campaignId) {
		return this.getRequest("GetCampaignNewsList", { campaignId: campaignId }, true, false);
	}

	getCampaignPartnerList(campaignId) {
		return this.getRequest("GetCampaignPartnerList", { campaignId: campaignId }, true, false);
	}

	getCampaignTestimonyList(campaignId) {
		return this.getRequest("GetCampaignTestimonyList", { campaignId: campaignId }, true, false);
	}
	
	getCampaignProjectList(campaignId, howMany, coverageName, causeId = 0) {
		return this.getRequest("GetCampaignProjectList", { campaignId: campaignId, howMany: howMany, coverageName: coverageName, causeId: causeId }, true, false);
	}

	getProjectCauseList(campaignId, coverageName) {
		return this.getRequest("GetProjectCauseList", { campaignId: campaignId, coverageName: coverageName }, true, false);
	}
	
	getProjectCoverageList(campaignId, causeId = 0) {
		return this.getRequest("GetProjectCoverageList", { campaignId: campaignId, causeId: causeId }, true, false);
	}

	getCampaignLandingPageConfigByCampaignId(campaignId) {
		return this.getRequest("GetCampaignLandingPageConfigByCampaignId", { campaignId: campaignId });
	}

	getCampaignLandingPageConfigByCampaignIdWithoutCarts(campaignId) {
		return this.getRequest("GetCampaignLandingPageConfigByCampaignIdWithoutCarts", { campaignId: campaignId });
	}

	GetCampaignApiList(campaignId){
		return this.getRequest("GetCampaignApiList", { campaignId: campaignId });
	}

	findById(callback, campaignId) {
		this.getRequest("FindById", { campaignId: campaignId }).then(callback);
	}

	listAll(entityId, companyId) {
		// if (companyId) {
			return this.getRequest('ListAllCampaigns', { entityId: entityId });
		// }
		// else {
		// 	return this.getRequest('ListAllCampaigns', { entityId: null });
		// }
	}

	listByQuery(query) {
		return this.getRequest('ListByQuery', { query: query });	
	}

	deleteCampaign(campaignId) {
		return this.deleteRequest('Delete', { id: campaignId });
	}

	publish(campaignId) {
		return this.postRequest('Publish', { campaignId: campaignId });
	}

	suspend(campaignId) {
		return this.postRequest('Suspend', { campaignId: campaignId }, false);
	}

	updateCapturedDonationValue(campaignId, capturedDonationValue) {
		return this.postRequest("UpdateCapturedDonationValue", { campaignId: campaignId, capturedDonationValue: capturedDonationValue }, false);
	}

	cloneCampaign(campaignId, subdomain) {
		return this.postRequest("Clone", { campaignId, subdomain }, true);
	}

	saveLandingPageConfig(campaignLandingPageConfig) {
		return this.postRequest("SaveLandingPageConfig", campaignLandingPageConfig, true, false);
	}

	saveDonationReceipt(campaignDonationReceipt) {
		return this.postRequest("SaveDonationReceipt", campaignDonationReceipt, true, false);
	}

	listFaqByCampaignId(callback, campaignId) {
		// Performance: cache por campaignId
		cachedRequest('faq_' + campaignId, () =>
			this.getRequest('ListFaqByCampaignId', { id: campaignId })
		).then(callback);
	}

	saveFaq(callback, faq) {
		// AUCR-773: invalida o cache de FAQ da(s) campanha(s) antes da request,
		// senao a proxima leitura devolve a lista antiga (com os recem-inseridos sem id)
		// e o admin acaba submetendo de novo com id=0, causando duplicacao no backend.
		const ids = new Set((Array.isArray(faq) ? faq : [faq]).map(f => f && f.campaignId).filter(Boolean));
		ids.forEach(id => delete _dataCache['faq_' + id]);
		this.postRequest('SaveFaq', faq).then(callback);
	}

	// Salva a lista de FAQ sem loader global nem mensagem (reorder otimista).
	saveFaqOrder(faqList) {
		return this.postRequest('SaveFaq', faqList, false, false);
	}

	deleteFaq(callback, faqId) {
		// AUCR-773: nao temos o campaignId aqui, limpa todas as entradas faq_*
		Object.keys(_dataCache).filter(k => k.startsWith('faq_')).forEach(k => delete _dataCache[k]);
		this.deleteRequest('DeleteFaq', { id: faqId }).then(callback);
	}

	// Override de visibilidade de uma pergunta da Base de Conhecimento para esta campanha.
	saveFaqOverride(override) {
		return this.postRequest('SaveFaqOverride', override);
	}

	listGeneralFaq(callback) {
		// Performance: cache global
		cachedRequest('generalFaq', () =>
			this.getRequest('ListGeneralFaq')
		).then(callback);
	}

	findBySubdomain(callback) {
		// Performance: cache + deduplicação — evita múltiplas chamadas simultâneas
		const promise = cachedRequest('findBySubdomain', () =>
			this.getRequest('FindBySubdomain')
		);
		if (callback) {
			promise.then(callback);
		}
		else{
			return promise;
		}
	}

	saveCampaignSubdomain(campaignId, newSubdomain) {
		return this.postRequest('SaveCampaignSubdomain', { campaignId: campaignId, newSubdomain: newSubdomain });
	}

	listAllCampaignMixAndPublicByCompanyId(companyId){
		return this.getRequest('ListAllCampaignMixAndPublicByCompanyId', {companyId: companyId});
	}

	listAllByCompanyId(companyId){
		return this.getRequest("ListAllByCompanyId", {companyId: companyId});
	}

	getAllPaymentMethods() {
		return this.getRequest('GetAllPaymentMethodsByCampaign', null, null, false)
	}

	// Payment methods consent terms

	ListAllPaymentMethodConsentTermsByCampaignId(campaignId = 0){
		return this.getRequest("ListAllPaymentMethodConsentTermsByCampaignId", {campaignId: campaignId});
	}

	savePaymentMethodConsentTerms(consentTermTexts){
		return this.postRequest('SavePaymentMethodConsentTerms', consentTermTexts);
	}

	GetConsentTermDefaultByPaymentMethodId(paymentMethodId = 0) {
		return this.getRequest("GetConsentTermDefaultByPaymentMethodId", {paymentMethodId: paymentMethodId});
	}

	ListAllDefaultConsentTerms(){
		return this.getRequest("ListAllDefaultConsentTerms");
	}

	showLGPD() {
		return this.getRequest("ShowLGPD");
	}
}